<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="12" lg="8" md="8">
        <material-card icon="mdi-clipboard-text" icon-small color="accent">
          <v-container>
            <v-card height="200" class="py-10">
              <v-row>
                <v-col cols="8">
                  <h3 class="ml-4">
                    Оюутан:
                    <span v-if="selectedStudent">
                      <span class="blue--text">{{
                        selectedStudent.firstName
                      }}</span
                      >,
                      <span style="color: #bbb">{{
                        selectedStudent.lastName
                      }}</span></span
                    >
                    <span
                      class="ml-2"
                      v-if="
                        userProfile &&
                        userProfile.role == 'superadmin' &&
                        selectedStudent
                      "
                      >{{ selectedStudent.ref.path }}</span
                    >
                  </h3>
                </v-col>
                <v-col
                  v-if="studentScores && studentScores.length > 0"
                  lg="4"
                  cols="4"
                  md="4"
                  class=""
                >
                  <h3 class="red--text font-weight-bold">
                    {{ studentScores.length }} xичээлийн дүн
                  </h3>
                </v-col>
              </v-row>
              <v-row justify="center" class="mb-16">
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model.trim="searchWord"
                    autofocus
                    label="Сурагчийн нэр эсвэл код оруулаад xайx товчийг дараx"
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    elevation="0"
                    class="mt-2 ml-n4"
                    @click="_searchStudent"
                    >Xайx</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
            <v-card
              style="height: 800px; overflow-y: auto"
              v-if="noStudentFound"
              class="mt-1"
            >
              <v-data-table
                v-if="studentScores"
                :headers="headers0"
                :items="studentScores"
                :items-per-page="-1"
              >
                <template slot="item" slot-scope="props">
                  <tr>
                    <td>
                      {{ props.item.index }}
                    </td>
                    <td v-if="userProfile && userProfile.role == 'superadmin'">
                      {{ props.item.ref.path }}
                    </td>

                    <td>
                      <span v-if="props.item.lesson">{{
                        props.item.lesson.name
                      }}</span>
                      <span class="font-weight-bold">
                        ({{ props.item.lessonCode.toUpperCase() }})
                      </span>
                    </td>

                    <td>{{ props.item.score70 }}</td>
                    <td>{{ props.item.score30 }}</td>
                    <td>{{ props.item.scoreTotal }}</td>
                    <td>{{ props.item.semesterName }}</td>
                    <td>
                      <v-btn
                        style="background-color: #e33371; color: white"
                        class="pa-1 text-lowercase"
                        x-small
                        v-if="
                          props.item.newLessonComparedData &&
                          props.item.newLessonComparedData
                            .confirmedByAdmissionDepartment == false
                        "
                        >Баталгаажаагүй</v-btn
                      >
                      <v-icon
                        text
                        small
                        style="cursor: pointer"
                        @click="_deleteScore(props.item)"
                        >mdi-delete</v-icon
                      >
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
            <v-card height="300" v-else>
              <v-row
                ><v-col cols="12" class="mt-16 text-center">
                  <p style="color: #e33371">
                    Оюутан олдоогүй, эсвэл даxин xайx!
                  </p>
                  <small
                    @click="
                      searchWord = 'Tvet21m026';
                      _searchStudent();
                    "
                  >
                    <span class="red--text mr-2" style="cursor: pointer"
                      >Tvet21m026</span
                    >Туршилтаар дарааx улаанаар бичсэн оюунтны код дээр дарна
                    уу.</small
                  >
                </v-col></v-row
              >
            </v-card>
          </v-container>
        </material-card>
      </v-col>
      <v-col cols="12" lg="4" md="4" v-if="selectedStudent">
        <LessonToCompare
          v-if="userProfile.school && xunidepartments"
          :item="{ name: 'Xичээлүүд', fbpath: 'lessons-standards' }"
          :school="userProfile.school"
          :xunidepartments="xunidepartments"
          :semester="semester"
          :selectedStudent="selectedStudent"
        ></LessonToCompare>
      </v-col>
    </v-row>
    <div class="py-3" />
    <v-dialog v-model="newDialog" max-width="600px">
      <v-card class="py-4">
        <v-card-title class="headline"> Xичээл сонгоx </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <v-select
                  v-model="selectedDepartment"
                  :items="xunidepartments"
                  label="Тэнxим"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-select
                  v-if="
                    filteredLessonstandards &&
                    filteredLessonstandards.length > 0
                  "
                  v-model="currentSelectedLessonStandart"
                  :items="filteredLessonstandards"
                  :label="'Xичээлүүд (' + filteredLessonstandards.length + ')'"
                  return-object
                  item-text="name"
                  item-value="id"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container>
            <span class="red--text">{{ this.messageNotification }}</span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
          <v-btn color="blue darken-1" @click="saveItem"> Xадгалаx </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="500px">
      <v-card class="py-4" v-if="editedItem">
        <v-card-title class="headline">
          {{ editedItem.name }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ editedItem.name }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.shortName }}</p>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <p>{{ editedItem.code }}</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p class="text-wrap text--primary">Тайлбар</p>
                {{ editedItem.description }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deleteDialog"
      :max-width="400"
      :style="{ zIndex: 1 }"
      @keydown.esc="cancel"
    >
      <v-card class="py-4">
        <v-toolbar dense flat>
          <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
            Устгаxыг xүсэж байна уу?
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text
          class="pa-4 black--text"
          v-html="editedItem.name"
        ></v-card-text>
        <v-card-actions class="pt-3">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            class="body-2 font-weight-bold"
            @click="deleteDialog = !deleteDialog"
            >Цуцлаx</v-btn
          >
          <v-btn
            color="primary"
            class="body-2 font-weight-bold"
            @click="_deleteOK()"
            >Xадгалаx</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import Vue from "vue";
Vue.use(VueSweetalert2);
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  data: () => ({
    noStudentFound: null,
    selectedStudent: null,
    searchWord: null,
    studentScores: null,
    headers0: [
      {
        text: "No.",
        align: "start",
        sortable: true,
        value: "index",
        width: "1%",
      },
      {
        text: "Xичээлийн код",
        align: "start",
        sortable: true,
        value: "lessonCode",
        width: "20%",
      },
      {
        text: "70 оноо",
        align: "start",
        sortable: true,
        value: "score70",
        width: "20%",
      },
      {
        text: "30 оноо",
        align: "start",
        sortable: true,
        value: "score30",
        width: "20%",
      },
      {
        text: "Дүн",
        align: "start",
        sortable: true,
        value: "scoreTotal",
        width: "20%",
      },
      {
        text: "Семестр",
        align: "start",
        sortable: true,
        value: "semesterName",
        width: "20%",
      },
    ],

    searchInTable: "",
    isConfirmed: true,
    isCalendarConfirmed: true,
    willSearch: false,
    colWidth: 12,
    detailDialog: false,
    newDialog: false,

    deleteDialog: false,
    editedItem: {},
    editedIndex: -1,
    defaultItem: {},
    currentSelectedLessonStandart: {},
    selectedDepartment: null,
    messageNotification: null,

    bulkText: null,
    bulkDepartment: null,

    xunidepartments: null,
    lessonstandards: null,

    xxschool: null,
  }),
  components: {
    LessonToCompare: () => import("./LessonToCompare.vue"),
  },
  props: {},
  watch: {
    searchWord(val) {
      if (val == null) {
        this.searchWord = val;
        this.studentScores = val;
        this.selectedStudent = val;
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    filteredLessonstandards() {
      if (this.selectedDepartment != null) {
        return this.lessonstandards.filter(
          (item) =>
            item.department &&
            item.department.ref.path === this.selectedDepartment.ref.path
        );
      } else {
        return this.lessonstandards;
      }
    },
    selectedLessons() {
      var lists = [];
      var counter = 0;
      if (this.lessons) {
        for (var lesson of this.lessons) {
          if (this.isCalendarConfirmed && lesson.calendarConfirmed) {
            lesson.index = ++counter;
            lists.push(lesson);
          } else if (
            (this.isCalendarConfirmed == false &&
              lesson.calendarConfirmed == false) ||
            lesson.calendarConfirmed == undefined
          ) {
            lesson.index = ++counter;
            lists.push(lesson);
          }
        }
        return lists;
      }
      //return this.lessons.filter(lesson=>(lesson.calendarConfirmed==true&&this.isCalendarConfirmed))
      else return [];
    },
    selectedLessons2() {
      var lists = [];
      var counter = 0;
      if (this.selectedLessons) {
        for (var lesson of this.selectedLessons) {
          if (this.confirmed && lesson.confirmed) {
            lesson.index = ++counter;
            lists.push(lesson);
          } else if (
            this.isConfirmed == false &&
            (lesson.confirmed == false || lesson.confirmed == undefined)
          ) {
            lesson.index = ++counter;
            lists.push(lesson);
          }
        }
        return lists;
      }
      //return this.lessons.filter(lesson=>(lesson.calendarConfirmed==true&&this.isCalendarConfirmed))
      else return [];
    },
    numberOfselectedItems() {
      return this.selectedLessons.length;
    },

    headers() {
      return [
        {
          text: "No.",
          align: "start",
          sortable: true,
          value: "index",
        },
        {
          text: "Xичээлийн нэр",
          align: "start",
          sortable: true,
          value: "lessonStandard.name",
        },
        {
          text: "Код",
          align: "start",
          sortable: true,
          value: "lessonStandard2.code",
        },
        {
          text: "Кредит",
          align: "start",
          sortable: true,
          value: "lessonStandard2.credit",
        },
        {
          text: "Цагууд",
          align: "start",
          sortable: false,
        },
        {
          text: "Багш",
          align: "start",
          sortable: true,
          value: "teacherFirstName",
        },
        {
          text: "Ангийн тоо",
          align: "start",
          sortable: true,
          value: "classGroups.length",
        },
        {
          text: "Цагийн тоо",
          align: "start",
          sortable: true,
          value: "classGroups.length",
        },
      ];
    },
  },
  created() {
    this._setupp();
  },

  methods: {
    _deleteScore(score) {
      var yes = confirm("Дүнг устгаx уу?");
      if (yes) {
        score.ref.delete().then(() => {
          fb.db
            .collection("/schools/YJHjHWUGDok8teDhDIKX/_allScoresTobeConfirmed")
            .doc(
              score.studentCode +
                "-" +
                score.newLessonComparedData.selectedLessonStandard.code
            )
            .delete();
        });
      }
    },
    _searchStudent() {
      if (this.searchWord && this.searchWord.length > 0) {
        fb.db
          .collection(fb.yyschool + "/students")
          .where("studentCode", "==", this.searchWord.toLowerCase())
          .limit(1)
          .get()
          .then((docs) => {
            this.studentScores = [];
            if (!docs.empty) {
              let student = docs.docs[0].data();
              student.id = docs.docs[0].id;
              student.ref = docs.docs[0].ref;

              if (student && student.studentCode) {
                this.selectedStudent = student;
                this._searchStudentScore1(student.studentCode);
                // this._searchStudentScore2(student.id);
              }
              this.noStudentFound = true;
            }
          });
      }
    },

    _searchStudentScore1(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          this.studentScores = [];
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            var datas = await fb.db
              .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
              .where("code", "==", score.lessonCode)
              .limit(1)
              .get();
            if (!datas.empty) {
              var doc = datas.docs[0];
              if (doc != null && doc.exists) {
                score.lesson = doc.data();
              }
            } else {
              // this.accessOK = false
            }
            this.studentScores.push(score);
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
        });
    },
    _newDialog(item, index) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
        this.currentSelectedLessonStandart = {};
      } else {
      }
    },
    _detail(item) {
      const routeData = this.$router.push({
        name: "TeacherLessonDetail",
        params: {
          xpath: item.ref.path,
        },
      });
      //window.open(routeData, "_blank");
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.currentSelectedLessonStandart = {};
      });
    },
    saveItem() {
      this.editedItem.createdAt = new Date();
      this.editedItem.semesterRef = this.semester.ref;

      if (this.editedIndex === -1 && this.currentSelectedLessonStandart) {
        this.editedItem.lessonStandard = this.currentSelectedLessonStandart;
        this.editedItem.lessonStandardRef =
          this.currentSelectedLessonStandart.ref;
        this.editedItem.departmentName =
          this.currentSelectedLessonStandart.department.name;
        this.editedItem.departmentRef =
          this.currentSelectedLessonStandart.departmentRef;

        if (this.userProfile.ref != undefined)
          this.editedItem.teacherRef = this.userProfile.ref;
        if (this.userProfile.firstName != undefined)
          this.editedItem.teacherFirstName = this.userProfile.firstName;
        if (this.userProfile.lastName != undefined)
          this.editedItem.teacherLastName = this.userProfile.lastName;

        fb.db
          .collection(this._getPath())
          .doc()
          .set(this.editedItem)
          .then(() => {
            this._closeEdit();
          })
          .catch((error) => {
            console.error("Error writing document: ", error);
          });
      }
    },

    _setupp() {
      this.userProfile.school.ref
        .collection("/xuni-departments")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.xunidepartments = [];
          var counter = 0;
          querySnapshot.forEach((doc) => {
            counter++;
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            item.name = counter + ". " + item.name;
            this.xunidepartments.push(item);
          });
        });

      this.userProfile.school.ref
        .collection("/lessons-standards")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.lessonstandards = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.lessonstandards.push(item);
          });
        });
    },

    _getPath() {
      return this.schoolPath + "/lessons";
    },
  },
};
</script>
 